export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_sc-3c17f5fd2d1f3780f0beec6c8b1f72bd.png";